export default __webpack_public_path__ + "static/media/rack1.969309fe.webp";